module.exports = __webpack_public_path__ + "public/images/zeroState.1542200237c311ef1cd2fb9cbbade8d6.svg";